import React, { useEffect, useState, useRef } from "react";
import { CDBIcon } from "cdbreact";
import { Pagination, Modal, Button, ProgressBar } from "react-bootstrap";
import moment from "moment-timezone";
import { useNavigate, } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx'; // Importa la biblioteca xlsx
import logotipo from '../../../img/Peiix_logotipo_color.png'
import loadingLogo from '../../../img/Peiix_isotipo_color.png'; // Importar el isotipo para el spinner
import NavBarPeiix from '../../NavBar';
import '../../../Styles/SpinnerOverlay.css'; // Importar los estilos del spinner
import { fetchTransactions, fetchUniqueDevices as fetchUniqueDevicesService } from "./Transactions/services/transactionService";
import { fetchMonthlySummary as fetchMonthlySummaryService, fetchDailySummary as fetchDailySummaryService } from "./Transactions/services/summaryService";
import { processRefund } from "./Transactions/services/refundService";
import { getCardImage } from "./Transactions/utils/imageHelpers";
import { getEstadoEtiqueta, renderEstado } from "./Transactions/utils/transactionHelpers";
import TransactionSummaryCards from "./Transactions/components/TransactionSummaryCards";
import TransactionTable from "./Transactions/components/TransactionTable";
import TransactionFilters from "./Transactions/components/TransactionFilters";
import RefundModal from "./Transactions/components/RefundModal";
import ExcelFilterModal from "./Transactions/components/ExcelFilterModal";
import PdfFilterModal from "./Transactions/components/PdfFilterModal";
import LoadingOverlay from "../../common/LoadingOverlay";


const Transacciones = () => {
  const [transacciones, setTransacciones] = useState([]);
  const [nombreComercial, setNombreComercial] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [error, setError] = useState(null);
  const [modalMessage, setModalMessage] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState(null);
  const [userRole, setUserRole] = useState('');
  const [isAccount, setIsAccount] = useState(null);
  const [isAggregator, setIsAggregator] = useState(null);
  const [filtros, setFiltros] = useState({
    fecha: null,
    transaccionId: '',
    ultimos4: '',
    tipo: [],
    estado: [],
    tarjetas: [],
    devices: [], // Asegúrate de que esto sea un arreglo desde el inicio
    propinas: [], // Nuevo filtro para propinas
  });
  const [deviceOptions, setDeviceOptions] = useState([]); // Estado para los dispositivos
  const [isClickedPdf, setIsClickedPdf] = useState(false);
  const [isClickedExcel, setIsClickedExcel] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0); // Estado para el progreso de descarga
  const [loading, setLoading] = useState(true); // Estado para controlar el spinner
  const [isDownloading, setIsDownloading] = useState(false); // Nuevo estado para la descarga
  const [fechaInicio, setFechaInicio] = useState(null);
  const [horaInicio, setHoraInicio] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);
  const [horaFin, setHoraFin] = useState(null);
  const [totalTransacciones, setTotalTransacciones] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [monthlyTotal, setMonthlyTotal] = useState(0);
  const [averageTicket, setAverageTicket] = useState(0);
  const [dailyTotalSales, setDailyTotalSales] = useState(0); // Nuevo estado para las ventas diarias
  const [summaryLoading, setSummaryLoading] = useState(true);
  const [dailySummaryLoading, setDailySummaryLoading] = useState(true); // Nuevo estado de carga para ventas diarias
  const [fechaFromMonthlySummary, setFechaFromMonthlySummary] = useState(null);
  const [fechaToMonthlySummary, setFechaToMonthlySummary] = useState(null);
  const [fechaFromDailySummary, setFechaFromDailySummary] = useState(null);
  const [fechaToDailySummary, setFechaToDailySummary] = useState(null);


  // Ref para prevenir llamadas concurrentes
  const isFetchingRef = useRef(false);
  const isInitialLoadRef = useRef(false);
  
  // Estado para controlar UI (botones, dropdowns) durante fetch
  const [isFetching, setIsFetching] = useState(false);
  
  // Estado para controlar la carga de dispositivos únicos
  const [isLoadingDevices, setIsLoadingDevices] = useState(false);


  const [showModal, setShowModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null); // Para guardar la transacción seleccionada

  const [showModalDevolucion, setShowModalDevolucion] = useState(false);
  const [amount, setAmount] = useState(''); // Inicializa el estado para el monto
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedButton, setSelectedButton] = useState(null); // Estado para el botón seleccionado

  const [showExcelFilterModal, setShowExcelFilterModal] = useState(false); // Nuevo estado para el modal de filtros de Excel
  const [excelFilters, setExcelFilters] = useState({ // Nuevo estado para los filtros del modal de Excel
    fechaInicioExcel: null,
    horaInicioExcel: null,
    fechaFinExcel: null,
    horaFinExcel: null,
    devicesExcel: [],
    tarjetasExcel: [],
    tipoExcel: [],
    estadoExcel: [],
    propinasExcel: [], 
  });

  const resetExcelFilters = () => {
    setExcelFilters({
      fechaInicioExcel: null,
      horaInicioExcel: null,
      fechaFinExcel: null,
      horaFinExcel: null,
      devicesExcel: [],
      tarjetasExcel: [],
      tipoExcel: [],
      estadoExcel: [],
      propinasExcel: [], // Resetear filtro de propinas
    });
  };

  const handleSelectChangeExcel = (value, field) => {
    setExcelFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSelectChangePdf = (value, field) => {
    setPdfFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const [showPdfFilterModal, setShowPdfFilterModal] = useState(false);
  const [pdfFilters, setPdfFilters] = useState({
    fechaInicioPdf: null,
    horaInicioPdf: null,
    fechaFinPdf: null,
    horaFinPdf: null,
    devicesPdf: [],
    tarjetasPdf: [],
    tipoPdf: [],
    estadoPdf: [],
    propinasPdf: [], // Nuevo filtro para propinas en PDF
    selectedPdfColumns: [],
  });

  const [knownMaskedCards, setKnownMaskedCards] = useState(new Set());

  const handleCloseModalDevolucion = () => {
    setShowModalDevolucion(false);
    setSelectedOption(null); // Reinicia la selección al cerrar
    setSelectedButton(null); // Reinicia la selección del botón al cerrar
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setSelectedButton(option); // Actualiza el botón seleccionado
  };


  useEffect(() => {
    const nombre = localStorage.getItem('nombre_comercial');
    if (nombre) {
      setNombreComercial(nombre);
    }
    const accountStatus = localStorage.getItem('is_account') === 'true';
    const aggregatorStatus = localStorage.getItem('is_aggregator') === 'true';
    setIsAccount(accountStatus);
    setIsAggregator(aggregatorStatus);
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  useEffect(() => {
    const accountStatus = localStorage.getItem('is_account') === 'true';
    setIsAccount(accountStatus); // Asegurarse de que isAccount esté actualizado aquí también

    if (accountStatus) { // Es una "Cuenta Actual"
      const existingUserTokens = localStorage.getItem('user_tokens_related');
      let userTokensRelated = [];

      if (existingUserTokens) {
        try {
          userTokensRelated = JSON.parse(existingUserTokens);
        } catch (err) {
          userTokensRelated = [];
        }
      }

      const cuentaPrincipal = {
        nombre: localStorage.getItem('nombre_comercial'),
        access_token: localStorage.getItem('access_token'),
        bp_token: localStorage.getItem('bp_token'),
        user_token: localStorage.getItem('user_token'),
        refresh_token: localStorage.getItem('refresh_token'),
      };

      const sucursalData = userTokensRelated.map(item => ({
        nombre: item.nombre_comercial,
        bp_token: item.bp_token,
        access_token: item.access_token,
        user_token: item.user_token,
        refresh_token: item.refresh_token,
      }));

      sucursalData.unshift(cuentaPrincipal);
      setSucursales(sucursalData);
      setSelectedSucursal(cuentaPrincipal);
    } else { // Es una "Cuentita"
      const cuentitaBranches = localStorage.getItem('cuentita_branches');
      let branchNames = [];
      if (cuentitaBranches) {
        try {
          branchNames = JSON.parse(cuentitaBranches);
        } catch (err) {
          branchNames = [];
        }
      }
      // Mapear los nombres de las sucursales a un formato compatible con el dropdown
      const cuentitaSucursales = branchNames.map(name => ({
        nombre: name,
        // Para cuentitas, no necesitamos bp_token ni user_token para la selección de sucursal,
        // ya que el filtrado se hará localmente. Solo necesitamos el nombre.
      }));

      // Añadir una opción "Todas las sucursales" al principio para cuentitas
      const allBranchesOption = { nombre: "Todas las sucursales", isAll: true };
      cuentitaSucursales.unshift(allBranchesOption);

      setSucursales(cuentitaSucursales);
      setSelectedSucursal(allBranchesOption); // Seleccionar "Todas las sucursales" por defecto
    }
  }, [isAccount]); // Añadir isAccount como dependencia para que se ejecute cuando cambie

  useEffect(() => {
    const role = localStorage.getItem('user_role');
    if (role) {
      setUserRole(role);
    }
  }, []);

  const getAccountType = () => {
    const currentIsAccount = localStorage.getItem('is_account') === 'true';
    const currentIsAggregator = localStorage.getItem('is_aggregator') === 'true';

    if (currentIsAggregator && currentIsAccount) return "Concentradora";
    if (!currentIsAggregator && !currentIsAccount) return "Cuentita";
    if (!currentIsAggregator && currentIsAccount) return "Cuenta Actual";
    return null;
  };

  const handleSucursalSelect = (sucursal) => {
    setSelectedSucursal(sucursal);
    setCurrentPage(1); // Reiniciar a la página 1 al cambiar de sucursal
    setDropdownOpen(false); // Cierra el dropdown al seleccionar una sucursal
    localStorage.setItem('selectedSucursal', JSON.stringify(sucursal)); // Guarda la sucursal seleccionada en localStorage
  };

  const userHasTokens = sucursales.length > 0;

  // Estado para la paginación
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 600; // Máximo para API v1
  const itemsPerPageC = 500; // Máximo para API v2
  const itemsPerPageMain = 500; // Para carga principal de API v1
  const itemsPerPageCMain = 500; // Para carga principal de API v2
  const [isModalOpen, setModalOpen] = useState(false);


  const fetchMonthlySummary = async (access_token, bp_token) => {
    setSummaryLoading(true);
    const accountType = getAccountType();
    if (!accountType || !access_token) return;

    try {
      const result = await fetchMonthlySummaryService({
        accessToken: access_token,
        bpToken: bp_token,
        accountType,
        limitV1: itemsPerPage,
        limitV2: itemsPerPageC
      });

      if (result.error === 'UNAUTHORIZED') {
        const newTokens = selectedSucursal ? await refreshSucursalTokens(selectedSucursal.refresh_token) : await refreshTokens();
        return fetchMonthlySummary(newTokens.access_token, newTokens.bp_token);
      }

      if (result.netTotal !== undefined) {
        setMonthlyTotal(result.netTotal);
        setAverageTicket(result.avgTicket);
        setFechaFromMonthlySummary(result.range.from);
        setFechaToMonthlySummary(result.range.to);
      }
    } catch (err) {
      console.error('Error al obtener el resumen mensual:', err);
      setMonthlyTotal(0);
      setAverageTicket(0);
    } finally {
      setSummaryLoading(false);
    }
  };

  const fetchDailySummary = async (access_token, bp_token) => {
    setDailySummaryLoading(true);
    const accountType = getAccountType();
    if (!accountType || !access_token) return;

    try {
      const result = await fetchDailySummaryService({
        accessToken: access_token,
        bpToken: bp_token,
        accountType,
        limitV1: itemsPerPage,
        limitV2: itemsPerPageC
      });

      if (result.error === 'UNAUTHORIZED') {
        const newTokens = selectedSucursal ? await refreshSucursalTokens(selectedSucursal.refresh_token) : await refreshTokens();
        return fetchDailySummary(newTokens.access_token, newTokens.bp_token);
      }

      if (result.netTotal !== undefined) {
        setDailyTotalSales(result.netTotal);
        setFechaFromDailySummary(result.range.from);
        setFechaToDailySummary(result.range.to);
      }
    } catch (err) {
      console.error('Error al obtener el resumen diario:', err);
      setDailyTotalSales(0);
    } finally {
      setDailySummaryLoading(false);
    }
  };


  const areFiltrosActivos = () => {
    return (
      fechaInicio ||
      fechaFin ||
      horaInicio ||
      horaFin ||
      filtros.transaccionId ||
      filtros.ultimos4 ||
      filtros.tipo.length > 0 ||
      filtros.estado.length > 0 ||
      filtros.tarjetas.length > 0 ||
      filtros.devices.length > 0 ||
      filtros.propinas.length > 0
    );
  };

  const fetchTransacciones = async (access_token, bp_token) => {
    setLoading(true);
    setModalMessage(null);
    setError(null);
    setIsFetching(true);

    const accountType = getAccountType();

    try {
      if (!accountType) {
        setModalMessage('No se pudo determinar el tipo de cuenta. Por favor, recargue la página e intente de nuevo.');
        return;
      }

      if (!access_token) {
        setModalMessage('Su sesión ha expirado o el token de acceso no está disponible. Por favor, cierre sesión y vuelva a iniciar.');
        return;
      }

      const result = await fetchTransactions({
        accessToken: access_token,
        bpToken: bp_token,
        accountType,
        page: currentPage,
        limit: accountType === "Cuenta Actual" ? itemsPerPageMain : itemsPerPageCMain,
        filters: filtros,
        fechaInicio, fechaFin, horaInicio, horaFin,
        knownMaskedCards
      });

      // Manejo de Re-autenticación (401)
      if (result.error === 'UNAUTHORIZED') {
        const newTokens = selectedSucursal ? await refreshSucursalTokens(selectedSucursal.refresh_token) : await refreshTokens();
        if (selectedSucursal) setSelectedSucursal(prev => ({ ...prev, ...newTokens }));
        return fetchTransacciones(newTokens.access_token, newTokens.bp_token);
      }

      // Manejo de Errores específicos
      if (result.error === 'CARD_NOT_FOUND') {
        setModalMessage("No se encontraron transacciones con los últimos 4 dígitos de tarjeta especificados. Solo se muestran transacciones de tarjetas previamente vistas.");
        setTransacciones([]);
        return;
      }

      // Éxito: Actualizar estados
      setTransacciones(result.data || []);
      setTotalTransacciones(result.totalItems || 0);
      setTotalPages(result.totalPages || 1);

      // Actualizar tarjetas conocidas (solo para Cuenta Actual)
      if (accountType === "Cuenta Actual" && result.data) {
        setKnownMaskedCards(prev => {
          const newCards = new Set(prev);
          result.data.forEach(t => { if (t.masked_card) newCards.add(t.masked_card); });
          return newCards;
        });
      }

      // Mensajes de resultado vacío
      if (!result.data || result.data.length === 0) {
        setModalMessage(areFiltrosActivos() 
          ? "No se encontraron transacciones que coincidan con los filtros aplicados."
          : "No hay transacciones disponibles. Si tienes sucursales, prueba seleccionando una para ver sus transacciones.");
      }

    } catch (err) {
      console.error('Error fetching transactions:', err);
    } finally {
      setLoading(false);
      setIsFetching(false);
    }
  };
  
  const realizarDevolucion = async (user_token) => {
    if (!selectedTransaction) return;

    const userToken = selectedSucursal ? selectedSucursal.user_token : user_token;
    const accessToken = selectedSucursal ? selectedSucursal.access_token : undefined;

    try {
      const result = await processRefund({
        accessToken,
        userToken,
        saleId: selectedTransaction.transaction_id
      });

      if (result.status === 200) {
        if (result.isApproved) {
          alert("Devolución realizada con éxito");
        }
      } else {
        const error = result.data;
        if (error?.responseCode === "023" && error?.message === "La transacción no existe o ya ha sido devuelta") {
          alert("La transacción no existe o ya ha sido devuelta");
        }
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      handleCloseModalDevolucion();
    }
  };

  const realizarDevolucionParcial = async (user_token) => {
    if (!selectedTransaction) return;

    if (!amount || parseFloat(amount) <= 10) {
      return;
    }

    const userToken = selectedSucursal ? selectedSucursal.user_token : user_token;
    const accessToken = selectedSucursal ? selectedSucursal.access_token : undefined;

    try {
      const result = await processRefund({
        accessToken,
        userToken,
        saleId: selectedTransaction.transaction_id,
        refundAmount: amount
      });

      if (result.status === 200) {
        if (result.isApproved) {
          alert("Devolución realizada con éxito");
        }
      } else {
        const error = result.data;
        if (error?.responseCode === "023" && error?.message === "La transacción no existe o ya ha sido devuelta") {
          alert("La transacción no existe o ya ha sido devuelta");
        }
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      handleCloseModalDevolucion();
    }
  };

  // Función para obtener nuevos tokens de sucursal
  const refreshSucursalTokens = async (refreshToken) => { // Verifica el valor del refresh token
    const apiUrl = process.env.REACT_APP_API_URL_DEV;
    try {
      const response = await fetch(`${apiUrl}/refresh`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "refresh_token": String(refreshToken)})
      });

      if (!response.ok) throw new Error('Error al actualizar tokens de sucursal.');

      const data = await response.json();
      // No guardamos en localStorage aquí, solo retornamos los nuevos tokens
      return data;
    } catch (error) {
      //console.error('Error al refrescar los tokens de sucursal:', error);
      throw error; // Lanzar error para manejarlo externamente
    }
  };

  // useEffect para carga inicial completa (con resúmenes)
  useEffect(() => {
    const fetchInitialData = async () => {
      // Prevenir llamadas concurrentes
      if (isFetchingRef.current) {
        setModalMessage('Ya hay una petición en curso, esperando...');
        return;
      }

      const currentAccessToken = selectedSucursal ? selectedSucursal.access_token : localStorage.getItem('access_token');
      const currentBpToken = selectedSucursal ? selectedSucursal.bp_token : localStorage.getItem('bp_token');

      let effectiveAccessToken = currentAccessToken;
      let effectiveBpToken = currentBpToken;

      // Si es una Cuentita, siempre usar los tokens del localStorage principal
      if (isAccount === false) {
        effectiveAccessToken = localStorage.getItem('access_token');
        effectiveBpToken = localStorage.getItem('bp_token');
      }

      if (effectiveAccessToken && (isAccount !== undefined) && (isAggregator !== undefined)) {
        isFetchingRef.current = true;
        setIsFetching(true); // Actualizar estado para UI
        isInitialLoadRef.current = true; // Marcar que estamos en carga inicial
        
        try {
          const accountType = getAccountType();
          const authParams = {
            accessToken: effectiveAccessToken,
            bpToken: !isAccount || (isAccount && isAggregator) ? null : effectiveBpToken,
            accountType
          };

          // 1. Cargar Transacciones
          await fetchTransacciones(authParams.accessToken, authParams.bpToken);
          
          // 2. Cargar Resúmenes y Dispositivos de forma concurrente
          setIsLoadingDevices(true);
          const [monthlyRes, dailyRes, devicesRes] = await Promise.all([
            fetchMonthlySummary(authParams.accessToken, authParams.bpToken),
            fetchDailySummary(authParams.accessToken, authParams.bpToken),
            fetchUniqueDevicesService({
              ...authParams,
              itemsPerPage,
              itemsPerPageC
            })
          ]);

          // Manejo de dispositivos
          if (devicesRes.error === 'UNAUTHORIZED') {
            const newTokens = selectedSucursal ? await refreshSucursalTokens(selectedSucursal.refresh_token) : await refreshTokens();
            if (selectedSucursal) setSelectedSucursal(prev => ({ ...prev, ...newTokens }));
            
            // Reintento único para dispositivos
            const retryDevices = await fetchUniqueDevicesService({
              accessToken: newTokens.access_token,
              bpToken: newTokens.bp_token,
              accountType,
              itemsPerPage,
              itemsPerPageC
            });
            if (retryDevices.data) setDeviceOptions(retryDevices.data);
          } else if (devicesRes.data) {
            setDeviceOptions(devicesRes.data);
          }

        } catch (err) {
          console.error("Error en carga inicial:", err);
        } finally {
          setIsLoadingDevices(false);
          isFetchingRef.current = false;
          setIsFetching(false); // Actualizar estado para UI
          // Esperar un poco antes de permitir que el segundo useEffect se ejecute
          setTimeout(() => {
            isInitialLoadRef.current = false;
          }, 500);
        }
      }
    };

    // Pequeño delay para evitar race conditions
    const timeoutId = setTimeout(() => {
      fetchInitialData();
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [selectedSucursal, isAccount, isAggregator]); // Solo cuando cambia sucursal o tipo de cuenta

  // useEffect separado para cambios de página y filtros (solo transacciones)
  useEffect(() => {
    const fetchPageData = async () => {
      // No ejecutar si estamos en carga inicial (cambio de sucursal)
      if (isInitialLoadRef.current) {

        return;
      }

      // Prevenir llamadas concurrentes
      if (isFetchingRef.current) {
        setModalMessage('Ya hay una petición en curso, esperando...');
        return;
      }

      // Validaciones de filtros para evitar fetches innecesarios
      
      // 1. Si hay fechas, deben estar AMBAS completas (inicio Y fin)
      const hasFechaInicio = fechaInicio !== null;
      const hasFechaFin = fechaFin !== null;
      
      if (hasFechaInicio && !hasFechaFin) {

        return;
      }
      
      if (!hasFechaInicio && hasFechaFin) {

        return;
      }

      // 1.1. Validar que las fechas sean lógicas y no futuras
      if (hasFechaInicio && hasFechaFin) {
        // fechaInicio y fechaFin ya son objetos Moment del DatePicker
        const hoy = moment().endOf('day'); // Usar endOf para permitir todo el día de hoy
        
        // Validar que fecha inicio no sea futura (después de hoy)
        if (fechaInicio.isAfter(hoy, 'day')) {

          setLoading(false);
          setModalMessage('La fecha de inicio no puede ser una fecha futura. Por favor, seleccione una fecha válida.');
          return;
        }

        // Validar que fecha fin no sea futura (después de hoy)
        if (fechaFin.isAfter(hoy, 'day')) {

          setLoading(false);
          setModalMessage('La fecha de fin no puede ser una fecha futura. Por favor, seleccione una fecha válida.');
          return;
        }

        // Validar que fecha inicio no sea mayor que fecha fin
        if (fechaInicio.isAfter(fechaFin, 'day')) {

          setLoading(false);
          setModalMessage('La fecha de inicio no puede ser posterior a la fecha de fin. Por favor, ajuste las fechas.');
          return;
        }
      }

      // 2. Si hay ID de transacción, debe tener exactamente 10 dígitos
      if (filtros.transaccionId && filtros.transaccionId.length > 0 && filtros.transaccionId.length < 9) {

        return;
      }

      // 3. Si hay últimos 4 dígitos, debe tener exactamente 4 caracteres
      if (filtros.ultimos4 && filtros.ultimos4.length > 0 && filtros.ultimos4.length < 4) {

        return;
      }

      const currentAccessToken = selectedSucursal ? selectedSucursal.access_token : localStorage.getItem('access_token');
      const currentBpToken = selectedSucursal ? selectedSucursal.bp_token : localStorage.getItem('bp_token');

      let effectiveAccessToken = currentAccessToken;
      let effectiveBpToken = currentBpToken;

      // Si es una Cuentita, siempre usar los tokens del localStorage principal
      if (isAccount === false) {
        effectiveAccessToken = localStorage.getItem('access_token');
        effectiveBpToken = localStorage.getItem('bp_token');
      }

      if (effectiveAccessToken && (isAccount !== undefined) && (isAggregator !== undefined)) {
        isFetchingRef.current = true;
        setIsFetching(true); // Actualizar estado para UI
        
        try {
          if (!isAccount || (isAccount && isAggregator)) { // Cuentita o Concentradora
            await fetchTransacciones(effectiveAccessToken, null); // Solo transacciones
          } else { // Cuenta actual
            if (effectiveBpToken) {
              await fetchTransacciones(effectiveAccessToken, effectiveBpToken); // Solo transacciones
            }
          }
        } finally {
          isFetchingRef.current = false;
          setIsFetching(false); // Actualizar estado para UI
        }
      }
    };

    // Debounce de 500ms para evitar fetches mientras el usuario escribe
    const timeoutId = setTimeout(() => {
      fetchPageData();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [currentPage, filtros, fechaInicio, horaInicio, fechaFin, horaFin]); // Solo cuando cambian página o filtros



  const handleShowModal = (transaccion) => {
    setSelectedTransaction(transaccion); // Almacena la transacción seleccionada
    setShowModal(true); // Abre el modal
    setShowModalDevolucion(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTransaction(null); // Reinicia la transacción seleccionada
  };

  // Función para obtener nuevos tokens
  const refreshTokens = async () => {
    const apiUrl = process.env.REACT_APP_API_URL_DEV;
    const refreshToken = localStorage.getItem('refresh_token');
    try {
      const response = await fetch(`${apiUrl}/refresh`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "refresh_token": String(refreshToken)})
      });

      if (!response.ok) throw new Error('Error al actualizar tokens.');

      const data = await response.json();
      localStorage.setItem('access_token', data.access_token);
      localStorage.setItem('refresh_token', data.refresh_token);
      localStorage.setItem('bp_token', data.bp_token);

      return data; // Regresar nuevos tokens
    } catch (error) {
      //console.error('Error al refrescar los tokens:', error);
      throw error; // Lanzar error para manejarlo externamente
    }
  };

  const handleInputChange = (e, key) => {
    setFiltros({ ...filtros, [key]: e.target.value });
    setCurrentPage(1); // Resetear a la página 1 al cambiar un filtro
  };

  const handleSelectChange = (value, key) => {
    setFiltros({ ...filtros, [key]: value });
    setCurrentPage(1); // Resetear a la página 1 al cambiar un filtro
  };

  const handleColumnSelectChange = (value) => {
    setSelectedColumns(value);
  };

  const limpiarFiltros = () => {
    setFiltros({
      fecha: null,
      transaccionId: '',
      ultimos4: '',
      tipo: [],
      estado: [],
      tarjetas: [],
      devices: [],
      propinas: [], // Limpiar filtro de propinas
    });
    setFechaInicio(null);
    setHoraInicio(null);
    setFechaFin(null);
    setHoraFin(null);
    setCurrentPage(1); // Resetear a la página 1 al limpiar filtros
  };


  const aplicarFiltros = () => {
    const startDate = fechaInicio
      ? moment(`${fechaInicio.format("DD/MM/YYYY")} ${horaInicio ? horaInicio.format("HH:mm") : "00:00"}`, "DD/MM/YYYY HH:mm")
      : null;

    const endDate = fechaFin
      ? moment(`${fechaFin.format("DD/MM/YYYY")} ${horaFin ? horaFin.format("HH:mm") : "23:59"}`, "DD/MM/YYYY HH:mm")
      : null;

    return transacciones.filter((transaccion) => {
      const estadoEtiqueta = getEstadoEtiqueta(transaccion);

      // Lógica de filtrado para Cuentitas por sucursal (esto es local y debe permanecer)
      const isCuentitaAndBranchSelected =
        isAccount === false &&
        selectedSucursal &&
        !selectedSucursal.isAll; // Si no es la opción "Todas las sucursales"

      const matchesBranch = isCuentitaAndBranchSelected
        ? transaccion.branch === selectedSucursal.nombre
        : true; // Si no es cuentita o es "Todas las sucursales", no aplicar este filtro

      // Lógica para filtrar por propinas (local)
      const tipAmount = parseFloat(transaccion.tip) || 0;
      const hasTip = tipAmount > 0;
      const noTip = tipAmount === 0;
      
      let matchesTipFilter = true;
      if (filtros.propinas.length > 0) {
        if (filtros.propinas.includes('con_propina') && !hasTip) {
          matchesTipFilter = false;
        }
        if (filtros.propinas.includes('sin_propina') && !noTip) {
          matchesTipFilter = false;
        }
      }

      // Lógica para filtrar por tarjetas (local)
      let matchesCardBrand = true;
      if (filtros.tarjetas.length > 0) {
        matchesCardBrand = filtros.tarjetas.map(tarjeta => tarjeta.toLowerCase().replace(/\s/g, '')).includes(transaccion.card_brand.toLowerCase().replace(/\s/g, ''));
      }

      // Lógica para filtrar por estado (local) para "Rechazada" en Cuenta Actual
      let matchesStatusFilter = true;
      if (isAccount && filtros.estado.includes('Rechazada') && !filtros.estado.includes('Aprobada') && !filtros.estado.includes('Devolucion')) {
        const rejectedStatuses = ['rechazada', 'rechazadaRiesgo', 'rechazadaProsa'];
        matchesStatusFilter = rejectedStatuses.includes(transaccion.transaction_status);
      } else if (isAccount && filtros.estado.includes('Aprobada') && filtros.estado.includes('Rechazada')) {
        // Si se seleccionan Aprobada y Rechazada, y la API solo devuelve Aprobadas,
        // entonces filtramos las rechazadas localmente.
        const rejectedStatuses = ['rechazada', 'rechazadaRiesgo', 'rechazadaProsa'];
        matchesStatusFilter = (transaccion.transaction_status === 'aprobada' && transaccion.transaction_type !== 'devolucion') || rejectedStatuses.includes(transaccion.transaction_status);
      }

      // Lógica para filtrar por tipo de tarjeta (local) para "Cuenta Actual"
      let matchesTypeFilter = true;
      if (isAccount && filtros.tipo.length > 0) {
        matchesTypeFilter = filtros.tipo.includes(transaccion.card_type);
      }

      return (
        matchesBranch &&
        matchesTipFilter &&
        matchesCardBrand &&
        matchesStatusFilter &&
        matchesTypeFilter
      );
    });
  };

  const allColumns = [
    { key: 'ID', label: 'ID', property: 'transaction_id', alwaysShow: true },
    { key: 'Fecha', label: 'Fecha', property: 'date', alwaysShow: true },
    { key: 'Hora', label: 'Hora', property: 'date', alwaysShow: true }, // Added property 'date' for Hora
    { key: 'Terminal', label: 'Terminal', property: 'device', alwaysShow: true },
    { key: 'Detalles', label: 'Detalles', property: 'details' },
    { key: 'No.Tarjeta', label: 'No.Tarjeta', property: 'masked_card', alwaysShow: true },
    { key: 'Tarjeta', label: 'Tarjeta', property: 'card_brand', alwaysShow: true },
    { key: 'Tipo', label: 'Tipo', property: 'card_type', alwaysShow: true },
    { key: 'Subtotal', label: 'Subtotal', property: 'subtotal' },
    { key: 'Propina', label: 'Propina', property: 'tip' },
    { key: 'Transacción', label: 'Transacción', property: 'total_amount', alwaysShow: true },
    { key: 'Comision', label: 'Comisión', property: 'agreed_commission_value', cuentitaOnly: true },
    { key: 'IVA Comision', label: 'IVA Comisión', property: 'iva_comm_val', cuentitaOnly: true },
    { key: 'Total', label: 'Total', property: 'trade_profit', cuentitaOnly: true },
    { key: 'Sucursal', label: 'Sucursal', property: 'branch'},
    { key: 'MSI', label: 'MSI', property: 'msi' },
    { key: 'Banco', label: 'Banco', property: 'bank', alwaysShow: true },
    { key: 'No. Autorizacion', label: 'No. Autorización', property: 'authorization_number', alwaysShow: true },
    { key: 'Estado', label: 'Estado', property: 'transaction_status', alwaysShow: true },

    //{ key: 'Acciones', label: 'Acciones', alwaysShow: true }
  ];

  const transaccionesFiltradas = aplicarFiltros(); // Mantener esta línea para aplicar filtros locales si es necesario
  const currentItems = transaccionesFiltradas; // Ahora transacciones ya contiene solo los items de la página actual
  
  // Filtrar columnas según el tipo de cuenta
  const isCuentitaAccount = !isAccount && !isAggregator;
  
  const defaultColumns = allColumns.filter((col) => {
    if (col.alwaysShow) return true;
    if (col.cuentitaOnly && isCuentitaAccount) return true;
    return false;
  });
  
  const selectableColumns = allColumns.filter((col) => {
    if (col.alwaysShow) return false;
    if (col.cuentitaOnly && !isCuentitaAccount) return false;
    return true;
  });

  const handleModalClose = () => {
    setShowModal(false); // Cerrar el modal
    handleLogout(); // Llamar a la función de cerrar sesión
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    // Supongamos que el token se almacena en el localStorage
    localStorage.removeItem('token'); // Limpia el token de autenticación
    localStorage.removeItem('bp_token');
    // Redirigir a la página de inicio de sesión
    navigate('/Inicio');
  };

  function descargarPDF() {
    setShowPdfFilterModal(true);
  }

  const handleDownloadPdfWithFilters = async () => {
    const { fechaInicioPdf, horaInicioPdf, fechaFinPdf, horaFinPdf, devicesPdf, tarjetasPdf, tipoPdf, estadoPdf, propinasPdf, selectedPdfColumns } = pdfFilters;

    if (!fechaInicioPdf || !horaInicioPdf || !fechaFinPdf || !horaFinPdf) {
      alert("Por favor, selecciona un rango de fecha y hora completo para la descarga.");
      return;
    }

    const columnsToExport = allColumns.filter(
      (col) => (col.alwaysShow || selectedPdfColumns.includes(col.key)) && col.key !== 'Acciones'
    );
    const orderedSelectedColumns = allColumns.filter(col => columnsToExport.some(c => c.key === col.key));

    if (orderedSelectedColumns.length === 0) {
      alert("Por favor, selecciona al menos una columna para exportar.");
      return;
    }

    setIsDownloading(true);
    setDownloadProgress(0);
    setShowPdfFilterModal(false);

    let allTransaccionesForPdf = [];
    let page = 1;
    const itemsPerPagePdf = 600; // Usar itemsPerPage para PDF
    const itemsPerPageCPdf = 500; // Usar itemsPerPageC para PDF
    let hasMoreData = true;
    let totalTransactionsFetched = 0;
    let totalItems = 0;

    const accountType = getAccountType();
    if (!accountType) {
      setError('Error al cargar las transacciones para PDF: No se pudo determinar el tipo de cuenta.');
      setIsDownloading(false);
      return;
    }

    let currentAccessToken = selectedSucursal?.access_token || localStorage.getItem('access_token');
    let currentBpToken = selectedSucursal?.bp_token || localStorage.getItem('bp_token');

    if (!currentAccessToken) {
      setError('Error al cargar las transacciones para PDF: Token de acceso no disponible.');
      setIsDownloading(false);
      return;
    }

    while (hasMoreData) {
      try {
        const result = await fetchTransactions({
          accessToken: currentAccessToken,
          bpToken: currentBpToken,
          accountType,
          page: page,
          limit: accountType === "Cuenta Actual" ? itemsPerPagePdf : itemsPerPageCPdf,
          filters: {}, // No enviamos filtros a la API para evitar errores de parámetros múltiples
          fechaInicio: fechaInicioPdf,
          fechaFin: fechaFinPdf,
          horaInicio: horaInicioPdf,
          horaFin: horaFinPdf
        });

        if (result.error === 'UNAUTHORIZED') {
          const newTokens = selectedSucursal ? await refreshSucursalTokens(selectedSucursal.refresh_token) : await refreshTokens();
          if (selectedSucursal) {
            setSelectedSucursal(prev => ({ ...prev, ...newTokens }));
          }
          currentAccessToken = newTokens.access_token;
          currentBpToken = newTokens.bp_token;
          continue;
        }

        const fetchedTransacciones = result.data || [];
        if (page === 1) {
          totalItems = result.totalItems || 0;
        }
        totalTransactionsFetched += fetchedTransacciones.length;
        const progress = totalItems > 0 ? Math.min(100, (totalTransactionsFetched / totalItems) * 100) : 0;
        setDownloadProgress(progress);

        // Filtrado local según la lógica del usuario
        const filteredData = fetchedTransacciones.filter(transaccion => {
          const estadoEtiqueta = getEstadoEtiqueta(transaccion);
          const matchesDevice = devicesPdf.length === 0 || devicesPdf.includes(transaccion.device);
          const matchesCard = tarjetasPdf.length === 0 || tarjetasPdf.map(t => t.toLowerCase().replace(/\s/g, '')).includes(transaccion.card_brand.toLowerCase().replace(/\s/g, ''));
          const matchesType = tipoPdf.length === 0 || tipoPdf.includes(transaccion.card_type);
          const matchesStatus = estadoPdf.length === 0 || estadoPdf.includes(estadoEtiqueta);
          
          const tipAmount = parseFloat(transaccion.tip) || 0;
          let matchesTipFilter = true;
          if (propinasPdf.length > 0) {
            if (propinasPdf.includes('con_propina') && tipAmount === 0) {
              matchesTipFilter = false;
            }
            if (propinasPdf.includes('sin_propina') && tipAmount > 0) {
              matchesTipFilter = false;
            }
          }
          
          return matchesDevice && matchesCard && matchesType && matchesStatus && matchesTipFilter;
        });

        allTransaccionesForPdf = allTransaccionesForPdf.concat(filteredData);

        if (fetchedTransacciones.length < (accountType === "Cuenta Actual" ? itemsPerPagePdf : itemsPerPageCPdf)) {
          hasMoreData = false;
        } else {
          page++;
        }
      } catch (err) {
        setError('Error al obtener las transacciones para PDF: ' + err.message);
        hasMoreData = false;
      }
    }

    if (allTransaccionesForPdf.length === 0) {
      alert("No se encontraron transacciones con los filtros seleccionados.");
      setIsDownloading(false);
      setDownloadProgress(0);
      return;
    }

    const doc = new jsPDF('landscape');
    const imgWidth = 65, imgHeight = 25;
    const pageWidth = doc.internal.pageSize.getWidth();
    const x = (pageWidth - imgWidth) / 2;
    doc.addImage(logotipo, 'PNG', x, 10, imgWidth, imgHeight);

    const pdfColumns = orderedSelectedColumns.map(c => c.label);
    const pdfData = allTransaccionesForPdf.map(transaccion => {
      const isCuentita = transaccion.total !== undefined && transaccion.total !== null;
      const totalAmount = isCuentita ? transaccion.total : transaccion.total_amount;
      const positiveTotalAmount = Math.abs(parseFloat(totalAmount) || 0);

      return orderedSelectedColumns.map(column => {
        switch (column.key) {
          case "ID": return transaccion.transaction_id;
          case "Fecha": return moment(transaccion.date).format("DD/MM/YYYY");
          case "Hora": return moment(transaccion.date).format("HH:mm");
          case "Terminal": return transaccion.device;
          case "Detalles": return transaccion.details;
          case "No.Tarjeta": return transaccion.masked_card.slice(6);
          case "Tarjeta": return transaccion.card_brand;
          case "Tipo": return transaccion.card_type === "DEBIT" ? "Debito" : "Credito";
          case "Tipo Tx": return transaccion.transaction_type;
          case "Subtotal":
            const subtotal = isCuentita ? transaccion.total_amount : transaccion.subtotal;
            return `$${parseFloat(subtotal || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
          case "Propina": return `$${parseFloat(transaccion.tip || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
          case "Transacción": return `$${totalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
          case "Comision": return `$${parseFloat(transaccion.agreed_commission_value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
          case "IVA Comision": return `$${parseFloat(transaccion.iva_comm_val || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
          case "Total": return `$${parseFloat(transaccion.trade_profit || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
          case 'Sucursal': return transaccion.branch;
          case "MSI": return transaccion.msi;
          case "Banco": return transaccion.bank;
          case "No. Autorizacion": return transaccion.authorization_number;
          case "Estado": return getEstadoEtiqueta(transaccion);
          default: return transaccion[column.property] || '';
        }
      });
    });

    const totalVentas = allTransaccionesForPdf.reduce((total, transaccion) => {
      if (transaccion.transaction_status === "aprobada" && transaccion.transaction_type !== "devolucion") {
        const isCuentita = transaccion.total !== undefined && transaccion.total !== null;
        const amount = isCuentita ? transaccion.total : transaccion.total_amount;
        return total + (parseFloat(amount) || 0);
      }
      return total;
    }, 0);

    const totalDevoluciones = allTransaccionesForPdf.reduce((total, transaccion) => {
      if (transaccion.transaction_status === "aprobada" && transaccion.transaction_type === "devolucion") {
        const isCuentita = transaccion.total !== undefined && transaccion.total !== null;
        const amount = isCuentita ? transaccion.total : transaccion.total_amount;
        return total + Math.abs(parseFloat(amount) || 0);
      }
      return total;
    }, 0);

    const totalNeto = totalVentas - totalDevoluciones;

    const formattedTotalVentas = `$${totalVentas.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    const formattedTotalDevoluciones = `-$${totalDevoluciones.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    const formattedTotalNeto = `$${totalNeto.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

    const numberOfColumns = pdfColumns.length;

    pdfData.push([
      { content: `Total ventas: ${formattedTotalVentas}`, colSpan: numberOfColumns, styles: { halign: 'right', fontStyle: 'bold' } }
    ]);
    pdfData.push([
      { content: `Total devoluciones: ${formattedTotalDevoluciones}`, colSpan: numberOfColumns, styles: { halign: 'right', fontStyle: 'bold' } }
    ]);
    pdfData.push([
      { content: `Total: ${formattedTotalNeto}`, colSpan: numberOfColumns, styles: { halign: 'right', fontStyle: 'bold' } }
    ]);

    doc.autoTable({
      head: [pdfColumns],
      body: pdfData,
      startY: 50,
      theme: 'striped',
      headStyles: { fillColor: '#3E4144', textColor: '#FFFFFF' },
      styles: { halign: 'center' },
      columnStyles: {
        0: { columnWidth: 15 } // Adjust width as needed for the ID column
      }
    });

    const fechaInicioStr = fechaInicioPdf ? fechaInicioPdf.format("DD_MM_YYYY") : 'SinFechaInicio';
    const fechaFinStr = fechaFinPdf ? fechaFinPdf.format("DD_MM_YYYY") : 'SinFechaFin';
    const nombreArchivoPDF = `Transacciones_Peiix_${fechaInicioStr}-${fechaFinStr}.pdf`;
    doc.save(nombreArchivoPDF);

    setIsDownloading(false);
    setDownloadProgress(0);
    setPdfFilters({
      fechaInicioPdf: null, horaInicioPdf: null, fechaFinPdf: null, horaFinPdf: null,
      devicesPdf: [], tarjetasPdf: [], tipoPdf: [], estadoPdf: [], propinasPdf: [], selectedPdfColumns: []
    });
  };

  const handleDownloadExcelWithFilters = async () => {
    const { fechaInicioExcel, horaInicioExcel, fechaFinExcel, horaFinExcel, devicesExcel, tarjetasExcel, tipoExcel, estadoExcel, propinasExcel } = excelFilters;

    // Validar campos obligatorios
    if (!fechaInicioExcel || !horaInicioExcel || !fechaFinExcel || !horaFinExcel) {
      alert("Por favor, selecciona un rango de fecha y hora completo para la descarga.");
      return;
    }

    setIsDownloading(true); // Activar el spinner de descarga
    setDownloadProgress(0);
    setShowExcelFilterModal(false); // Cerrar el modal al iniciar la descarga

    let allTransaccionesForExcel = [];
    let page = 1;
    const itemsPerPage = 600;
    const itemsPerPageC = 500;
    let hasMoreData = true;
    let totalTransactionsFetched = 0;
    let totalItems = 0;

    const accountType = getAccountType();
    if (!accountType) {
      setError('Error al cargar las transacciones para Excel: No se pudo determinar el tipo de cuenta.');
      setIsDownloading(false);
      return;
    }

    let currentAccessToken = selectedSucursal?.access_token || localStorage.getItem('access_token');
    let currentBpToken = selectedSucursal?.bp_token || localStorage.getItem('bp_token');

    if (!currentAccessToken) {
      setError('Error al cargar las transacciones para Excel: Token de acceso no disponible.');
      setIsDownloading(false);
      return;
    }

    while (hasMoreData) {
      try {
        const result = await fetchTransactions({
          accessToken: currentAccessToken,
          bpToken: currentBpToken,
          accountType,
          page: page,
          limit: accountType === "Cuenta Actual" ? itemsPerPage : itemsPerPageC,
          filters: {}, // Evitamos parámetros múltiples en la API
          fechaInicio: fechaInicioExcel,
          fechaFin: fechaFinExcel,
          horaInicio: horaInicioExcel,
          horaFin: horaFinExcel
        });

        if (result.error === 'UNAUTHORIZED') {
          const newTokens = selectedSucursal ? await refreshSucursalTokens(selectedSucursal.refresh_token) : await refreshTokens();
          if (selectedSucursal) {
             setSelectedSucursal(prev => ({ ...prev, ...newTokens }));
          }
          currentAccessToken = newTokens.access_token;
          currentBpToken = newTokens.bp_token;
          continue;
        }

        const fetchedTransacciones = result.data || [];
        if (page === 1) {
          totalItems = result.totalItems || 0;
        }
        totalTransactionsFetched += fetchedTransacciones.length;
        const progress = totalItems > 0 ? Math.min(100, (totalTransactionsFetched / totalItems) * 100) : 0;
        setDownloadProgress(progress);

        // Filtrado local según la lógica del usuario
        const filteredData = fetchedTransacciones.filter(transaccion => {
          const estadoEtiqueta = getEstadoEtiqueta(transaccion);
          const matchesDevice = devicesExcel.length === 0 || devicesExcel.includes(transaccion.device);
          const matchesCard = tarjetasExcel.length === 0 || tarjetasExcel.map(t => t.toLowerCase().replace(/\s/g, '')).includes(transaccion.card_brand.toLowerCase().replace(/\s/g, ''));
          const matchesType = tipoExcel.length === 0 || tipoExcel.includes(transaccion.card_type);
          const matchesStatus = estadoExcel.length === 0 || estadoExcel.includes(estadoEtiqueta);
          
          const tipAmount = parseFloat(transaccion.tip) || 0;
          let matchesTipFilter = true;
          if (propinasExcel.length > 0) {
            if (propinasExcel.includes('con_propina') && tipAmount === 0) {
              matchesTipFilter = false;
            }
            if (propinasExcel.includes('sin_propina') && tipAmount > 0) {
              matchesTipFilter = false;
            }
          }
          
          return matchesDevice && matchesCard && matchesType && matchesStatus && matchesTipFilter;
        });

        allTransaccionesForExcel = allTransaccionesForExcel.concat(filteredData);

        if (fetchedTransacciones.length < (accountType === "Cuenta Actual" ? itemsPerPage : itemsPerPageC)) {
          hasMoreData = false;
        } else {
          page++;
        }

      } catch (err) {
        setError('Error al obtener las transacciones para Excel: ' + err.message);
        hasMoreData = false;
      }
    }

    if (allTransaccionesForExcel.length === 0) {
      alert("No se encontraron transacciones con los filtros seleccionados.");
      setIsDownloading(false);
      setDownloadProgress(0);
      return;
    }

    // Preparar los datos para Excel
    const excelData = allTransaccionesForExcel.map(transaccion => {
      const estadoLabel = getEstadoEtiqueta(transaccion);

      // Determinar el subtotal y el monto total basado en el tipo de cuenta
      const isCuentita = transaccion.total !== undefined && transaccion.total !== null;
      const subtotal = isCuentita ? transaccion.total_amount : transaccion.subtotal;
      const totalAmount = isCuentita ? transaccion.total : transaccion.total_amount;
      const isCuentitaAccountType = accountType === "Cuentita";

      const rowData = {
        'ID': transaccion.transaction_id,
        'Fecha': moment(transaccion.date).format("DD/MM/YYYY"),
        'Hora': moment(transaccion.date).format("HH:mm"),
        'Terminal': transaccion.device,
        'No.Tarjeta': transaccion.masked_card.slice(6),
        'Tarjeta': transaccion.card_brand,
        'Tipo': transaccion.card_type === "DEBIT" ? "Debito" : "Credito",
        'Subtotal': parseFloat(subtotal) || 0,
        'Propina': parseFloat(transaccion.tip) || 0,
        'Transacción': totalAmount,
      };

      if (isCuentitaAccountType) {
        rowData['Comision'] = parseFloat(transaccion.agreed_commission_value) || 0;
        rowData['IVA Comision'] = parseFloat(transaccion.iva_comm_val) || 0;
        rowData['Total'] = parseFloat(transaccion.trade_profit) || 0;
      }
      
      rowData['Banco'] = transaccion.bank || 0;
      rowData['No. Autorizacion'] = transaccion.authorization_number || 0;
      rowData['Estado'] = estadoLabel;

      return rowData;
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, worksheet, 'Transacciones Filtradas');

    const fechaInicioStr = fechaInicioExcel ? fechaInicioExcel.format("DD_MM_YYYY") : 'SinFechaInicio';
    const fechaFinStr = fechaFinExcel ? fechaFinExcel.format("DD_MM_YYYY") : 'SinFechaFin';
    const nombreArchivoExcel = `Transacciones_Peiix_${fechaInicioStr}-${fechaFinStr}.xlsx`;

    XLSX.writeFile(wb, nombreArchivoExcel);

    setIsClickedExcel(!isClickedExcel);
    setTimeout(() => {
      setIsClickedExcel(false);
    }, 100);
    setIsDownloading(false); // Desactivar el spinner de descarga
    setDownloadProgress(0);
    resetExcelFilters(); // Limpiar los filtros después de la descarga
  };

  // Paginación Logica
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const maxVisiblePages = 5; // Máximo de páginas visibles
  let items = [];

  // Botón First
  items.push(
    <Pagination.First
      key="first"
      onClick={() => handlePageChange(1)}
      disabled={isFetching || currentPage === 1}
    />
  );

  // Botón anterior
  items.push(
    <Pagination.Prev
      key="prev"
      onClick={() => handlePageChange(currentPage - 1)}
      disabled={isFetching || currentPage === 1}
    />
  );

  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  // Ajustar el inicio si hay menos de 5 páginas visibles
  if (endPage - startPage < maxVisiblePages - 1) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  for (let number = startPage; number <= endPage; number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === currentPage}
        onClick={() => handlePageChange(number)}
        disabled={isFetching}
      >
        {number}
      </Pagination.Item>
    );
  }

  // Botón siguiente
  items.push(
    <Pagination.Next
      key="next"
      onClick={() => handlePageChange(currentPage + 1)}
      disabled={isFetching || currentPage === totalPages}
    />
  );

  // Botón Last
  items.push(
    <Pagination.Last
      key="last"
      onClick={() => handlePageChange(totalPages)}
      disabled={isFetching || currentPage === totalPages}
    />
  );

  return (
    <>
      <div className="Transacciones">
        <NavBarPeiix />
        {error && (
          <div className="error-message" style={{ 
            backgroundColor: '#f8d7da', 
            color: '#721c24', 
            border: '1px solid #f5c6cb', 
            padding: '10px', 
            borderRadius: '5px', 
            margin: '10px 40px', 
            textAlign: 'center',
            fontWeight: 'bold'
          }}>
            {error}
          </div>
        )}
        {isModalOpen && (
          <Modal show={isModalOpen} onHide={handleModalClose} centered>
            <Modal.Body className="text-center p-4">
              <CDBIcon icon="exclamation-circle" size="7x" style={{ color: "#ff6961" }} />
              <h3 className="fw-bold mt-4">Tu sesión ha expirado. Por favor, cierra sesión y vuelve a iniciar.</h3>
              <Button variant="danger" className="fw-bold h5 mt-3" onClick={handleModalClose} style={{ borderRadius: '10px' }}>
                Aceptar
              </Button>
            </Modal.Body>
          </Modal>
        )}
        {modalMessage && (
          <div className="modal" style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', // Fondo semitransparente
            zIndex: 999,
          }}>
            <div className="modal-content" style={{
              backgroundColor: '#fff3cd', // Fondo color amarillo pálido para advertencia
              borderRadius: '8px',
              padding: '20px',
              border: '1px solid #ffeeba',
              width: '400px',
              textAlign: 'center',
              position: 'relative'
            }}>
              <span className="close" onClick={() => setModalMessage(null)} style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '18px'
              }}>&times;</span>
              <h2 style={{ color: '#856404' }}>
                <CDBIcon icon="exclamation-triangle" style={{ marginRight: '5px' }} />
                Advertencia
              </h2>
              <p style={{ color: '#856404' }}>{modalMessage}</p>
              <button onClick={() => setModalMessage(null)} style={{
                backgroundColor: '#ffc107',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                color: 'white',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}>Aceptar</button>
            </div>
          </div>
        )}

        <div className='navbar-container' style={{ padding: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className='navbar-imgl' style={{ flex: '0 0 auto' }}>
            <h3 className=" fw-bold" style={{ color: '#3E3E3E', fontFamily: 'Montserrat, sans-serif', marginBottom: '0', display: 'flex', alignItems: 'center' }}>
              <CDBIcon icon="exchange-alt" /> Transacciones
            </h3>
          </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexGrow: 1, gap: '10px' }}>
              {((isAccount && sucursales.length > 1) || (!isAccount && sucursales.length > 2)) && (
                <Dropdown isOpen={dropdownOpen && !isFetching} toggle={isFetching ? undefined : toggleDropdown}>
                  <DropdownToggle
                    caret
                    disabled={isFetching}
                    style={{
                      height: 'auto',
                      borderRadius: '5px',
                      border: '1px solid #F2F2F2',
                      backgroundColor: isFetching ? '#E0E0E0' : '#F2F2F2',
                      color: isFetching ? '#9E9E9E' : '#3E3E3E',
                      fontWeight: 'bold',
                      fontFamily: 'Montserrat, sans-serif',
                      whiteSpace: 'nowrap',
                      cursor: isFetching ? 'not-allowed' : 'pointer',
                      opacity: isFetching ? 0.6 : 1
                    }}
                  >
                    <CDBIcon icon="map-marker-alt" />
                    {selectedSucursal ? selectedSucursal.nombre : "Sucursales"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {sucursales.map((sucursal, index) => (
                      <DropdownItem key={index} onClick={() => handleSucursalSelect(sucursal)}>
                        {sucursal.nombre}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              )}
              <Button 
                title={isFetching ? "Cargando..." : "Recargar transacciones"}
                disabled={isFetching}
                onClick={() => {
                  if (isFetching) return; // Prevenir clicks durante carga
                  
                  let effectiveAccessToken = selectedSucursal ? selectedSucursal.access_token : localStorage.getItem('access_token');
                  let effectiveBpToken = selectedSucursal ? selectedSucursal.bp_token : localStorage.getItem('bp_token');

                  // Si es una Cuentita, siempre usar los tokens del localStorage principal
                  if (isAccount === false) {
                    effectiveAccessToken = localStorage.getItem('access_token');
                    //effectiveBpToken = localStorage.getItem('bp_token');
                  }
                  fetchTransacciones(effectiveAccessToken, effectiveBpToken);
                }}
                style={{
                  height: 'auto',
                  borderRadius: '5px',
                  border: '1px solid #F2F2F2',
                  backgroundColor: isFetching ? '#E0E0E0' : '#F2F2F2',
                  color: isFetching ? '#9E9E9E' : '#3E3E3E',
                  fontWeight: 'bold',
                  fontFamily: 'Montserrat, sans-serif',
                  whiteSpace: 'nowrap',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: isFetching ? 'not-allowed' : 'pointer',
                  opacity: isFetching ? 0.6 : 1
                }}
              >
                <CDBIcon icon={isFetching ? "spinner" : "sync-alt"} className={isFetching ? "me-2 fa-spin" : "me-2"}/>
                {isFetching ? "Cargando..." : "Recargar transacciones"}
              </Button> 
            </div>
        </div>

        <br />

        <TransactionSummaryCards
          monthlyTotal={monthlyTotal}
          averageTicket={averageTicket}
          dailyTotalSales={dailyTotalSales}
          summaryLoading={summaryLoading}
          dailySummaryLoading={dailySummaryLoading}
          fechaFromMonthlySummary={fechaFromMonthlySummary}
          fechaToMonthlySummary={fechaToMonthlySummary}
          fechaFromDailySummary={fechaFromDailySummary}
          fechaToDailySummary={fechaToDailySummary}
        />

        <br />

        <TransactionFilters
          fechaInicio={fechaInicio} setFechaInicio={setFechaInicio}
          horaInicio={horaInicio} setHoraInicio={setHoraInicio}
          fechaFin={fechaFin} setFechaFin={setFechaFin}
          horaFin={horaFin} setHoraFin={setHoraFin}
          filtros={filtros} setFiltros={setFiltros}
          deviceOptions={deviceOptions}
          isLoadingDevices={isLoadingDevices}
          handleInputChange={handleInputChange}
          handleSelectChange={handleSelectChange}
          descargarPDF={descargarPDF}
          setShowExcelFilterModal={setShowExcelFilterModal}
          selectableColumns={selectableColumns}
          handleColumnSelectChange={handleColumnSelectChange}
          limpiarFiltros={limpiarFiltros}
          isClickedPdf={isClickedPdf}
          isClickedExcel={isClickedExcel}
        />

        <TransactionTable
          transactions={currentItems}
          allColumns={allColumns}
          selectedColumns={selectedColumns}
          userRole={userRole}
          isAccount={isAccount}
          getCardImage={getCardImage}
          getEstadoEtiqueta={getEstadoEtiqueta}
          renderEstado={renderEstado}
          handleShowModal={handleShowModal}
        />

        <RefundModal
          show={showModalDevolucion}
          handleClose={handleCloseModalDevolucion}
          selectedTransaction={selectedTransaction}
          selectedOption={selectedOption}
          handleOptionSelect={handleOptionSelect}
          amount={amount}
          setAmount={setAmount}
          realizarDevolucion={realizarDevolucion}
          realizarDevolucionParcial={realizarDevolucionParcial}
        />

        <PdfFilterModal
          show={showPdfFilterModal}
          handleClose={() => setShowPdfFilterModal(false)}
          pdfFilters={pdfFilters}
          setPdfFilters={setPdfFilters}
          deviceOptions={deviceOptions}
          isLoadingDevices={isLoadingDevices}
          handleSelectChangePdf={handleSelectChangePdf}
          descargarPDFDirecto={handleDownloadPdfWithFilters}
          selectableColumns={selectableColumns}
        />

        <ExcelFilterModal
          show={showExcelFilterModal}
          handleClose={() => setShowExcelFilterModal(false)}
          excelFilters={excelFilters}
          setExcelFilters={setExcelFilters}
          deviceOptions={deviceOptions}
          isLoadingDevices={isLoadingDevices}
          handleSelectChangeExcel={handleSelectChangeExcel}
          descargarExcel={handleDownloadExcelWithFilters}
          resetExcelFilters={resetExcelFilters}
        />


        <br />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Pagination>{items}</Pagination>
        </div>
      </div>
      <LoadingOverlay show={loading} message="Cargando sus transacciones..." />
      <LoadingOverlay 
        show={isDownloading} 
        message="Generando Archivo..." 
        progress={downloadProgress} 
      />
    </>
  );
};

export default Transacciones;